import { HttpClient } from "@angular/common/http";
import { inject, Inject, Injectable } from "@angular/core";
import { EnvConfig, Environment } from "@doc/core";
import { BehaviorSubject } from "rxjs";
import { ApiUrls } from "../backoffice-urls";

@Injectable({
  providedIn: "root",
})
export class DepartmentDashboardService {
  private http = inject(HttpClient);
  private apiUrl: string;

  constructor(@Inject(EnvConfig) private config: Environment) {
    this.apiUrl = this.config.apiUrl;
  }

  private _headerDataSubject = new BehaviorSubject<any>(null);
  headerData$ = this._headerDataSubject.asObservable();

  private _typeDataSubject = new BehaviorSubject<any>(null);
  typeData$ = this._typeDataSubject.asObservable();

  private _secondHeaderDataSubject = new BehaviorSubject<{
    left: any;
    right: any;
  }>({
    left: null,
    right: null,
  });
  secondHeaderDataSubject$ = this._secondHeaderDataSubject.asObservable();

  private _chartDataSubject = new BehaviorSubject<any>(null);
  chartDataSubject$ = this._chartDataSubject.asObservable();

  setChartData(data: any) {
    this._chartDataSubject.next(data);
  }

  get currentChartData() {
    return this._chartDataSubject.value;
  }

  setSecondHeaderDataLeft(data: any) {
    const current = this._secondHeaderDataSubject.value;
    this._secondHeaderDataSubject.next({ ...current, left: data });
    this.setChartData(null);
  }

  setSecondHeaderDataRight(data: any) {
    const current = this._secondHeaderDataSubject.value;
    this._secondHeaderDataSubject.next({ ...current, right: data });
    this.setChartData(null);
  }
  get currentSecondHeaderDataLeft() {
    return this._secondHeaderDataSubject.value.left;
  }

  get currentSecondHeaderDataRight() {
    return this._secondHeaderDataSubject.value.right;
  }

  setHeaderData(data: any) {
    this._headerDataSubject.next(data);
    this.setTypeData(null);
  }

  get currentHeaderData() {
    return this._headerDataSubject.value;
  }

  setTypeData(data: any) {
    this._typeDataSubject.next(data);
    this.setSecondHeaderDataLeft(null);
    this.setSecondHeaderDataRight(null);
  }

  get currentTypeData() {
    return this._typeDataSubject.value;
  }

  GetPrecedentDashboardCounts(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoCounts;
    return this.http.post<any>(link, body);
  }

  GetRecommendationsCount(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoRecommendationsCount;
    return this.http.post<any>(link, body);
  }

  GetParticipantNamesPerDep(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoParticipantNamesPerDep;
    return this.http.post<any>(link, body);
  }

  GetPrecedentCategoryTwoCounts(body: any) {
    const link =
      this.apiUrl + ApiUrls.GetDashboardTwoPrecedentCategoryTwoCounts;
    return this.http.post<any>(link, body);
  }

  GetStatusCounts(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoStatusCounts;
    return this.http.post<any>(link, body);
  }

  GetPrecedentDocumentDetails(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoDocumentDetails;
    return this.http.post<any>(link, body);
  }

  getParticipantsAccordionData(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoDocumentPomDetails;
    return this.http.post<any>(link, body);
  }

  GetRecommendationDetails(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoRecommendationDetails;
    return this.http.post<any>(link, body);
  }

  GetDocumentWorkFlowDetails(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoDocumentWorkFlowDetails;
    return this.http.post<any>(link, body);
  }

  GetParticipationMinutesPerDep(body: any) {
    const link =
      this.apiUrl + ApiUrls.GetDashboardTwoParticipationMinutesPerDep;
    return this.http.post<any>(link, body);
  }

  GetDashboardTwoParticipantPerDocument(body: any) {
    const link = this.apiUrl + ApiUrls.GetDashboardTwoParticipantPerDocument;
    return this.http.post<any>(link, body);
  }

  GetPrecedentCategoryTwoMonthlyCounts(body: any) {
    const link =
      this.apiUrl + ApiUrls.GetDashboardTwoPrecedentCategoryTwoMonthlyCounts;
    return this.http.post<any>(link, body);
  }

  FilterDropDownValues(id: any) {
    const link =
      this.apiUrl + ApiUrls.GetDashboardTwoFilterDropDownValues + "?" + id;
    return this.http.get<any>(link);
  }

  GetDashboardSubject(id: number) {
    const link =
      this.apiUrl + ApiUrls.GetDashboardTwoDashboardSubject + "/" + id;
    return this.http.get<any>(link);
  }

  ExportReport(body: any) {
    const link = this.apiUrl + ApiUrls.ExportDashboardTwoPrecedentDashboardData;
    return this.http.post(link, body, { responseType: "blob" });
  }
}
